import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import RenderContent from 'app/components/layout/RenderContent';

import * as paymentsActions from 'app/ducks/payments/actions';
import * as paymentCollectionsActions from 'app/ducks/paymentCollections/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as teamMembersActions from 'app/ducks/teamMembers/actions';

import * as paymentsSelectors from 'app/ducks/payments/selectors';
import * as paymentCollectionsSelectors from 'app/ducks/paymentCollections/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';
import PaymentDetail from './components/PaymentDetail';
import PaymentList from './components/PaymentList';

interface IPaymentsLayoutProps {
  actions: any;
  teams: any;
  teamMembers: any;
  payments: any;
  paymentCollections: any;
  match: any;
}

function selector(state): any {
  return {
    payments: paymentsSelectors.getPayments(state),
    paymentCollections: paymentCollectionsSelectors.getPaymentCollections(
      state,
    ),
    teams: teamsSelectors.getTeams(state),
    teamMembers: teamMembersSelectors.getTeamMembers(state),
  };
}

const actionCreators = _.merge(
  paymentsActions,
  paymentCollectionsActions,
  teamsActions,
  teamMembersActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class PaymentsLayout extends React.Component<
IPaymentsLayoutProps,
{}
> {
  static defaultProps: IPaymentsLayoutProps = {
    actions: undefined,
    teamMembers: undefined,
    payments: undefined,
    teams: undefined,
    paymentCollections: undefined,
    match: undefined,
  };

  renderPaymentList(): React.ReactNode {
    return (
      <PaymentList
        payments={this.props.payments.payments}
        paymentCollections={
          this.props.paymentCollections.totalPaymentCollections
        }
        hasLoaded={this.props.payments.hasLoaded}
        totalPaymentCollectionsLoaded={
          this.props.paymentCollections.totalPaymentCollectionsLoaded
        }
        {...this.props.actions}
      />
    );
  }

  renderPaymentDetail(paymentId): React.ReactNode {
    return (
      <PaymentDetail
        {...this.props}
        paymentId={paymentId}
        currentPayment={this.props.payments.currentPayment}
        teams={this.props.teams}
        teamMembers={this.props.teamMembers}
        payments={this.props.payments}
        paymentCollections={this.props.paymentCollections}
      />
    );
  }

  renderSubPage(): React.ReactNode {
    if (this.props.match.path === '/payments') {
      return this.renderPaymentList();
    }
    if (
      this.props.match.path === '/payments/:paymentId'
      && this.props.match.params.paymentId != null
    ) {
      return this.renderPaymentDetail(this.props.match.params.paymentId);
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="row">
          <div className="col">{this.renderSubPage()}</div>
        </div>
      </RenderContent>
    );
  }
}
